import { faBan, faCheck, faEdit, faFile, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { Button } from 'react-bootstrap';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import Gasto from '../../components/modals/GastoModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import Validado from '../../components/project/Validado';
import { apiDelete, apiForm, apiGet, apiUrl, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';

export default function Gastos(props) {
    // default filter
    const usuario = getSession();
    const defaultFilter = {
        desde: moment().startOf('year').format("YYYY-MM-DD"),
        hasta: null,
        trabajador: props.super ? null : usuario.id,
        pendiente: props.super ? true : null,
        validado: props.super ? null : true
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("gastos/table", filter);
    }
    const deleteRow = async id => await apiDelete("gastos/delete/" + id);
    const performAction = async (action, id) => await apiGet(`gastos/${action}/${id}`);

    // render
    return <>
        <h2>{`${props.super ? "Validar" : "Solicitar"} gastos`}</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            onAction={performAction}
            elementText="el gasto">
            <ValidacionFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectFechas
                selectDepartamento={props.super && usuario.permisoAdmin}
                selectTrabajador={props.super}
                selectEstado />
            <GastosTable
                super={props.super} />
        </TableHandler>
    </>;
}

function GastosTable(props) {
    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true,
            omit: !props.super
        },
        {
            name: "Fecha",
            selector: row => moment(row.Fecha).format("YYYY-MM-DD"),
            format: row => moment(row.Fecha).format("DD/MM/YY"),
            sortable: true
        },
        {
            name: "Categoría",
            selector: row => sortableString(row.NombreCategoria),
            format: row => row.NombreCategoria,
            sortable: true
        },
        {
            name: "Cliente",
            selector: row => sortableString(row.NombreCliente),
            format: row => row.NombreCliente,
            sortable: true
        },
        {
            name: "Cantidad",
            selector: row => row.Cantidad,
            format: row => `${row.Cantidad} €`.replace(".", ","),
            sortable: true
        },
        {
            name: "Validación",
            selector: row => row.Pendiente ? 0 : row.Validado ? 1 : 2,
            format: row => <Validado pendiente={row.Pendiente} validado={row.Validado} size="lg" />,
            sortable: true,
            center: true
        }
    ];

    // table buttons
    const buttons = row => {
        const viewBtn = <a href={apiUrl("gastos/justificante/" + row.Id)} target="_blank"><Button variant="primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        const viewBtnOutlined = <a href={apiUrl("gastos/justificante/" + row.Id)} target="_blank" > <Button variant="outline-primary" size="sm"><FontAwesomeIcon icon={faFile} /></Button></a>;
        return <>{
            props.super ?
                (row.Pendiente ?
                    <>
                        {/* super && pendiente */}
                        {viewBtn}
                        <Button title="Aprobar" action="validate" variant="success" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faCheck} /></Button>
                        <Button title="Denegar" action="invalidate" variant="danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faTimes} /></Button>
                    </> :
                    (row.Validado ? <>
                        {/* super && !pendiente && validado */}
                        {viewBtn}
                        <Button title="Cancelar" action="cancel" variant="outline-danger" size="sm" onClick={props.onAction}><FontAwesomeIcon icon={faBan} /></Button>
                    </> : <>
                        {/* super && !pendiente && !validado */}
                        {viewBtnOutlined}
                    </>)
                ) :
                (row.Pendiente ?
                    <>
                        {/* !super && pendiente */}
                        {viewBtn}
                        <Button variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></Button>
                        <Button variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></Button>
                    </> : (row.Validado ? <>
                        {/* !super && !pendiente && validado */}
                        {viewBtn}
                    </> : <>
                        {/* !super && !pendiente && !validado */}
                        {viewBtnOutlined}
                    </>)
                )
        }</>;
    };
    const name = row => (props.super ? `${row.NombreTrabajador}, ` : "") + ` ${row.Cantidad}€ por ${row.NombreCategoria}`;

    // render
    return <>
        <DataTable responsive rowname={name} buttons={buttons} columns={columns} data={props.data} pagination />
        {props.formOpen && (
            <Gasto
                show={props.formOpen}
                onHide={props.onFormClose}
                idGasto={props.formId}
            />
        )}
        {!props.super && <FloatingAddButton onClick={props.onNew} />}
    </>;
}
